import { render, staticRenderFns } from "./studentManagement.vue?vue&type=template&id=2a3e5a84&scoped=true"
import script from "./studentManagement.vue?vue&type=script&lang=js"
export * from "./studentManagement.vue?vue&type=script&lang=js"
import style0 from "./studentManagement.vue?vue&type=style&index=0&id=2a3e5a84&prod&lang=less&scoped=true"
import style1 from "./studentManagement.vue?vue&type=style&index=1&id=2a3e5a84&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3e5a84",
  null
  
)

export default component.exports